import React from 'react';
import { DeleteButton, EditButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';

/**
 * @param Boolean editing
 * @param Function setEditing
 * @param Function handleDelete 
 * @param Function handleUpdate
 * @param Boolean loading
 * @param Boolean disableDelete
 * @
 *
 * Renders an edit button, once clicked will show a set of delete and save buttons.
 *
 * Once delete or save buttons these buttons will disappear and edit will show!
 * *
 */

const EditButtonsSet = _ref => {
  let {
    isImmutableUnderReview = false,
    editing,
    setEditing,
    handleDelete,
    handleUpdate,
    loading,
    disableDelete,
    deleteProps
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, editing ? /*#__PURE__*/React.createElement("div", null, !disableDelete && /*#__PURE__*/React.createElement(DeleteButton, {
    isImmutableUnderReview: isImmutableUnderReview,
    style: {
      marginRight: '8px'
    },
    onClick: () => handleDelete(deleteProps)
  }), /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    icon: "save",
    loading: loading,
    onClick: () => handleUpdate()
  }, t('save'))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EditButton, {
    isImmutableUnderReview: isImmutableUnderReview,
    onClick: () => setEditing(true)
  })));
};
export default EditButtonsSet;